// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".airport-master .el-table th.airport-code,\n.airport-master .el-table td.airport-code {\n  width: 9em !important;\n}", ""]);
// Exports
module.exports = exports;
